export default {
  methods: {
    renderTopTrend(data) {
      // const categories = (data && data.months) || [];
      // const current = (data && data.current) || [];
      // const previous = (data && data.previous) || [];
      // const rate = (data && data.rate) || [];

      const categories = (data && data.map(item => item.month)) || [];
      const current = (data && data.map(item => item.nowData)) || [];
      const previous = (data && data.map(item => item.prevData)) || [];
      const rate = (data && data.map(item => (item.yoy && item.yoy.replace('%', '')) || 0)) || [];

      const option = {
        tooltip: {
          trigger: 'axis',
          // axisPointer: { type: 'cross' },
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#ccc',
              width: 1,
              type: [5, 10]
            },
            crossStyle: {
              color: '#ccc'
            }
          },
          formatter(params) {
            const dataIndex = params[0].dataIndex;
            const lines = params.map(p => {
              return `${p.marker}${p.seriesName.substring(0, 2)}：${p.value}`;
            });
            // 添加同比数据
            if (rate[dataIndex] !== undefined && rate[dataIndex] !== null) {
              const markerPlaceholder = '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#fff;"></span>';
              lines.push(`${markerPlaceholder}同比：${rate[dataIndex]}%`);
            }
            return `${params[0].axisValue}<br/>${lines.join('<br/>')}`;
          }
        },
        legend: {
          right: 10,
          textStyle: {
            color: '#fff',
            fontFamily: 'PingFangSC'
          },
          data: ['当期数量', '上期数量']
        },
        grid: {
          left: 50,
          right: 20,
          top: 40,
          bottom: 20
        },
        dataZoom: [
          {
            type: 'inside',
            xAxisIndex: [0],
            start: 0,
            end: Math.min(100, (12 / Math.max(categories.length, 1)) * 100)
          }
        ],
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: categories,
          axisLabel: {
            color: '#fff',
            fontSize: 12,
            fontFamily: 'PingFangSC'
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.2)'
            }
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          min: 0,
          axisLabel: {
            color: '#fff',
            fontSize: 12,
            fontFamily: 'PingFangSC'
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.1)',
              type: 'dashed'
            }
          }
        },
        series: [{
            name: '当期数量',
            type: 'line',
            smooth: true,
            symbol: 'none',
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                    offset: 0,
                    color: 'rgba(11, 183, 142, 1)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(41, 201, 106,0.1)'
                  }
                ]
              }
            },
            lineStyle: {
              color: 'rgba(11, 183, 142, 1)',
              width: 2
            },
            itemStyle: {
              color: 'rgba(11, 183, 142, 1)'
            },
            data: current
          },
          {
            name: '上期数量',
            type: 'line',
            smooth: true,
            symbol: 'none',
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                    offset: 0,
                    color: 'rgba(255, 155, 0, 1)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(255, 199, 0,0.05)'
                  }
                ]
              }
            },
            lineStyle: {
              color: 'rgba(255, 155, 0, 1)',
              width: 2
            },
            itemStyle: {
              color: 'rgba(255, 155, 0, 1)'
            },
            data: previous
          }
        ]
      };

      const $instance = this.$echarts.init(this.$refs['topTrend']);
      this.$refs['topTrend'].removeAttribute('_echarts_instance_');
      $instance.setOption(option);
      window.onresize = $instance.resize;
    }
  }
}
